module.exports = __webpack_public_path__ + "img/comparison-extra-card.07d7182.png";